export default "__VITE_ASSET__623b6d8b__"